module.exports = __webpack_public_path__ + "static/img/code.9f680963.png";